import { apiClient } from '@src/services/http-common'
import { CalculateTrendRequest, TeamMonthlyDviDto } from '@src/types/dvi'
import { useQuery } from '@tanstack/react-query'

const DVI_SCOPE = 'dvi'

const keysFactory = {
  teamTrend: (fromDate: string, toDate: string) => [DVI_SCOPE, 'team', 'trend', fromDate, toDate] as const,
}

// Raw async function for team DVI trend
export async function getTeamDviTrend(fromDate: string, toDate: string): Promise<TeamMonthlyDviDto[]> {
  const request: CalculateTrendRequest = { fromDate, toDate }
  const response = await apiClient.post<TeamMonthlyDviDto[]>('/Dvi/Calculate/Team/Trend', request)
  return response.data
}

// React Query hook for team DVI trend
export function useTeamDviTrend(fromDate: string, toDate: string): [TeamMonthlyDviDto[] | undefined, boolean] {
  const { isFetching, data } = useQuery({
    queryFn: () => getTeamDviTrend(fromDate, toDate),
    queryKey: keysFactory.teamTrend(fromDate, toDate),
  })
  return [data, isFetching]
}
